import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
// import { Chart, PieController, ArcElement, Tooltip, Legend } from 'chart.js';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { HOSPITAL_INFO_KEYWORDS, HospitalTitlecasePipe } from '../../../../../../pipes/hospital-titlecase.pipe';

@Component({
  selector: 'app-modal-pot-per-reg-hospitals',
  imports: [CommonModule, HospitalTitlecasePipe],
  templateUrl: './modal-pot-per-reg-hospitals.component.html',
  styleUrl: './modal-pot-per-reg-hospitals.component.css'
})
export class ModalPotPerRegHospitalsComponent implements OnInit {

  @Input() regionId!: number | null;
  @Input() medicineId!: number;
  @Input() countryId!: number;
  @Input() regionName!: string | null;
  @Input() regionPercentage!: string;
  @Input() experienceNumber: number = 0;

  // chart: any;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  hospitalList: any[] = [];
  isLoading = true;

  get isDataEmpty(): boolean {
    return !this.isLoading && this.hospitalList.length === 0;
  }

  /*
  --- Data for the pie chart (previous version, kept for the future) ---
  labelsData?: string[] = [];
  percentageData?: string[] = [];
  backgroundColors?: string[] = [];
  hasMoreSpanToOverflow: boolean = false;
  */

  constructor(private dataService: DataService) { }

  /*
  private readonly keywordSet = new Set(
    HOSPITAL_INFO_KEYWORDS.map((k: string) => k.toUpperCase())
  );
  */

  ngOnInit(): void {
    if (!this.regionId) {
      this.isLoading = false;
      return;
    }

    this.dataService
      .getHospitalInfoData(this.medicineId, this.countryId, this.regionId)
      .subscribe({
        next: (data: any) => {
          if (data.length > 0) {

            const totalPotentialNumber = data.reduce(
              (sum: number, item: any) => sum + item.potentialNumber,
              0
            );

            this.hospitalList = data
              .map((item: any) => {

                const potentialPercentage = totalPotentialNumber
                  ? (item.potentialNumber / totalPotentialNumber) * 100
                  : 0;

                const italyPercentage = this.experienceNumber
                  ? (item.potentialNumber * 100) / this.experienceNumber
                  : 0;

                return {
                  ...item,
                  potentialPercentage: potentialPercentage.toFixed(2),
                  italyPercentageRaw: italyPercentage,
                  italyPercentage: italyPercentage.toFixed(2)
                };
              })
              .sort((a: any, b: any) => b.italyPercentageRaw - a.italyPercentageRaw);
            /*
            --- OLD LOGIC: pie chart (kept for the future) ---
            data.map((item: any) => {
              let potentialPercentage = totalPotentialNumber ? (item.potentialNumber / totalPotentialNumber) * 100 : 0;
              this.labelsData?.push(item.name);
              this.percentageData?.push(potentialPercentage.toFixed(2).toString());
            });

            this.backgroundColors = this.getRandomColors(data.length);
            this.createPieChart();
            */

          } else {
            this.hospitalList = [];
          }
        },
        error: (error) => {
          console.error('Errore durante il caricamento dei dati:', error);
          this.hospitalList = [];
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  oncloseModal(value: boolean) {
    this.isLoading = false;
    this.closeModal.emit(value);
    this.hospitalList = [];

    /*
    this.backgroundColors = [];
    this.labelsData = [];
    this.percentageData = [];
    */
  }
}

  /*
  createPieChart (): void {
    Chart.register(PieController, ArcElement, Tooltip, Legend);

    const ctx = document.getElementById('myPieChart') as HTMLCanvasElement;
    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: this.labelsData,
        datasets: [{
          data: this.percentageData,
          backgroundColor: this.backgroundColors,
        }],
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true },
        },
      },
    });

    this.generateCustomLabels();
    this.isLoading = false;
  }

  generateCustomLabels (): void {
    const legendContainer = document.getElementById('pieChartLabels');

    if (legendContainer) {
      legendContainer.innerHTML = '';

      const labelsData = this.labelsData ?? [];
      const backgroundColors = this.backgroundColors ?? [];
      const percentageData = this.percentageData ?? [];

      labelsData.forEach((label, index) => {
        const color = backgroundColors[index] ?? '#cccccc';
        const percentage = percentageData[index] ?? 0;
        const titleLabel = this.toTitleCase(label);

        const labelElement = document.createElement('div');
        labelElement.innerHTML = `
          <div style="display: inline-block; width: 15px; height: 15px; background-color: ${color}; margin-right: 8px;"></div>

          <span>${titleLabel} &nbsp;-&nbsp; <h1 class="inline">${parseFloat(percentage).toFixed(2)}%</h1></span>
        `;
        labelElement.style.display = 'flex';
        labelElement.style.alignItems = 'center';
        labelElement.style.marginBottom = '5px';

        legendContainer.appendChild(labelElement);
        if (legendContainer.querySelectorAll("span").length > 8) {
          this.hasMoreSpanToOverflow = true;
        } else {
          this.hasMoreSpanToOverflow = false;
        }
      });
    } else {
      console.error('Legend container not found.');
    }
  }

  toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => {
        const upper = word.toUpperCase();
        if (this.keywordSet.has(upper)) {
          return upper;
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  getRandomColors(length: number): string[] {
    const colors: string[] = [];
    for (let i = 0; i < length; i++) {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      colors.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
    }
    return colors;
  }

  getHeight(): string {
    const length = this.labelsData?.length || 0;
    if (length < 10) return '300px';
    if (length >= 11 && length <= 15) return '350px';
    if (length > 15) return '400px';
    return 'auto';
  }
  */
